import { primitiveColors } from './primitiveColors'

export const semanticInteractive = {
  /// from design system
  fillThemeDefault: primitiveColors.pColorTheme600,
}
